import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5225327c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "official-form"
};
const _hoisted_2 = {
  class: "dialog-box",
  style: {
    "position": "relative",
    "width": "50%"
  }
};
const _hoisted_3 = {
  class: "official-form-preview"
};
import { ElMessage } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import { useCommon } from '@/common/hooks/useCommon';
import { useLayoutStore, useStaticDictStore } from '@/store';
import { useDownload } from '@/common/hooks/useDownload';
import { useDropdown } from '@/common/hooks/useDropdown';
import { useUpload } from '@/common/hooks/useUpload';
import { useUploadWidget } from '@/common/hooks/useUploadWidget';
import { DictionaryController } from '@/api/system';
import { findItemFromList } from '@/common/utils';
import { OfficialDocController } from '@/api/generated';
import OfficialDocPreview from '@/pages/officialDoc/officialDocPreview.vue';

import { ref, reactive, computed, onMounted } from 'vue';
// 表单数据
const __default__ = {
  name: 'formEditOfficialDoc'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    subPage: {
      type: [Number, String, Boolean],
      default: 0
    },
    id: {
      default: undefined
    },
    saveOnSubmit: {
      type: Boolean,
      default: true
    },
    rowData: {
      default: undefined
    },
    dialog: {
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const layoutStore = useLayoutStore();
    const {
      downloadFile
    } = useDownload();
    const {
      getUploadHeaders,
      getUploadActionUrl,
      fileListToJson,
      parseUploadData,
      getPictureList
    } = useUpload();
    const {
      Delete,
      Search,
      Edit,
      Plus,
      Refresh,
      Picture,
      Dialog,
      mainContextHeight,
      clientHeight,
      checkPermCodeExist,
      parseParams,
      parseArrayParams,
      formatDateByStatsType,
      getDateRangeFilter
    } = useCommon();
    // 静态字典
    const {
      staticDict: StaticDict
    } = useStaticDictStore();
    const props = __props;
    const formEditOfficialDocRef = ref();
    // 表单数据定义
    const formData = reactive({
      OfficialDoc: {
        // 主键Id
        id: undefined,
        // 套红模版ID
        redTemplateId: undefined,
        // 标题
        title: undefined,
        // 企字
        enterpriseCharacter: undefined,
        // 年份
        yearStr: undefined,
        // 第几号文
        numStr: undefined,
        // 保密级别
        securityLevel: undefined,
        // 保密期限
        securityRange: undefined,
        // 紧急程度
        urgency: undefined,
        // 公开级别
        openLevel: undefined,
        // 发文日期
        sendDate: undefined,
        // 发文机构
        sendDept: undefined,
        sendStatus: undefined,
        // 收文机构
        receiveDept: undefined,
        // 公文内容
        content: undefined,
        // 备注
        remark: undefined,
        // 附件
        attachFiles: undefined,
        // 状态
        status: undefined,
        // 流程状态
        flowStatus: undefined,
        // 创建者Id
        createUserId: undefined,
        // 创建人
        createUserName: undefined,
        // 创建时间
        createTime: undefined,
        // 更新者Id
        updateUserId: undefined,
        // 更新人
        updateUserName: undefined,
        // 最后更新时间
        updateTime: undefined,
        // 删除标记(0: 正常 1: 已删除)
        deletedFlag: undefined
      }
    });
    // 表单验证规则
    const rules = reactive({
      'OfficialDoc.securityLevel': [],
      'OfficialDoc.securityRange': [],
      'OfficialDoc.sendDate': [{
        required: true,
        message: '请输入发文日期',
        trigger: 'blur'
      }],
      'OfficialDoc.sendDept': [{
        required: true,
        message: '请输入发文机构',
        trigger: 'blur'
      }],
      'OfficialDoc.urgency': [],
      'OfficialDoc.openLevel': [],
      'OfficialDoc.enterpriseCharacter': [{
        required: true,
        message: '请输入企字',
        trigger: 'blur'
      }],
      'OfficialDoc.remark': [],
      'OfficialDoc.yearStr': [{
        required: true,
        message: '请输入年份',
        trigger: 'blur'
      }],
      'OfficialDoc.attachFiles': [],
      'OfficialDoc.redTemplateId': [{
        required: true,
        message: '请输入套红模版ID',
        trigger: 'blur'
      }],
      'OfficialDoc.receiveDept': [{
        required: true,
        message: '请输入收文机构',
        trigger: 'blur'
      }],
      'OfficialDoc.title': [{
        required: true,
        message: '请输入标题',
        trigger: 'blur'
      }],
      'OfficialDoc.content': [{
        required: true,
        message: '请输入公文内容',
        trigger: 'blur'
      }],
      'OfficialDoc.numStr': [{
        required: true,
        message: '请输入第几号文',
        trigger: 'blur'
      }]
    });
    const onCancel = () => {
      if (props.dialog) {
        props.dialog.cancel();
      }
    };
    const isEdit = computed(() => {
      return props.saveOnSubmit ? props.id != null : props.rowData != null;
    });
    // 初始化页面数据
    const loadOfficialDocData = () => {
      return new Promise((resolve, reject) => {
        if (!isEdit.value) {
          resolve();
          return;
        }
        if (!props.saveOnSubmit && props.rowData != null) {
          formData.OfficialDoc = JSON.parse(JSON.stringify(props.rowData));
          resolve();
          return;
        }
        let params = {
          id: props.id
        };
        OfficialDocController.view(params).then(res => {
          formData.OfficialDoc = {
            ...res.data
          };
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    };
    /**
     * 套红模版ID下拉数据获取函数
     */
    const loadRedTemplateIdDropdownList = () => {
      return new Promise((resolve, reject) => {
        const params = {};
        DictionaryController.dictRedTemplate(params).then(res => {
          resolve({
            dataList: res.getList()
          });
        }).catch(e => {
          reject(e);
        });
      });
    };
    // 套红模版ID配置参数
    const redTemplateIdOptions = {
      loadData: loadRedTemplateIdDropdownList,
      isTree: false
    };
    // 套红模版ID下拉组件
    const redTemplateIdWidget = useDropdown(redTemplateIdOptions);
    const {
      dropdownList: redTemplateIdWidgetDropdownList
    } = redTemplateIdWidget;
    /**
     * 保密级别下拉数据获取函数
     */
    const loadSecurityLevelDropdownList = () => {
      return Promise.resolve({
        dataList: StaticDict.SecurityLevel.getList()
      });
    };
    // 保密级别配置参数
    const securityLevelOptions = {
      loadData: loadSecurityLevelDropdownList,
      isTree: false
    };
    // 保密级别下拉组件
    const securityLevelWidget = useDropdown(securityLevelOptions);
    const {
      dropdownList: securityLevelWidgetDropdownList
    } = securityLevelWidget;
    /**
     * 保密期限下拉数据获取函数
     */
    const loadSecurityRangeDropdownList = () => {
      return Promise.resolve({
        dataList: StaticDict.SecurityRange.getList()
      });
    };
    // 保密期限配置参数
    const securityRangeOptions = {
      loadData: loadSecurityRangeDropdownList,
      isTree: false
    };
    // 保密期限下拉组件
    const securityRangeWidget = useDropdown(securityRangeOptions);
    const {
      dropdownList: securityRangeWidgetDropdownList
    } = securityRangeWidget;
    /**
     * 紧急程度下拉数据获取函数
     */
    const loadUrgencyDropdownList = () => {
      return Promise.resolve({
        dataList: StaticDict.Urgency.getList()
      });
    };
    // 紧急程度配置参数
    const urgencyOptions = {
      loadData: loadUrgencyDropdownList,
      isTree: false
    };
    // 紧急程度下拉组件
    const urgencyWidget = useDropdown(urgencyOptions);
    const {
      dropdownList: urgencyWidgetDropdownList
    } = urgencyWidget;
    /**
     * 公开级别下拉数据获取函数
     */
    const loadOpenLevelDropdownList = () => {
      return Promise.resolve({
        dataList: StaticDict.OpenLevel.getList()
      });
    };
    // 公开级别配置参数
    const openLevelOptions = {
      loadData: loadOpenLevelDropdownList,
      isTree: false
    };
    // 公开级别下拉组件
    const openLevelWidget = useDropdown(openLevelOptions);
    const {
      dropdownList: openLevelWidgetDropdownList
    } = openLevelWidget;
    /**
     * 附件上传文件改变
     */
    const onAttachFilesChange = val => {
      formData.OfficialDoc.attachFiles = fileListToJson(val);
    };
    // 附件上传文件组件
    const attachFilesWidget = useUploadWidget(10);
    const {
      fileList: attachFilesWidgetFileList,
      maxCount: attachFilesWidgetMaxCount
    } = attachFilesWidget;
    const onUploadError = () => {
      ElMessage.error('文件上传失败');
    };
    const onUploadLimit = () => {
      ElMessage.error('已经超出最大上传个数限制');
    };
    const refreshFormEditOfficialDoc = () => {
      // 刷新段落
    };
    /**
     * 重置过滤值
     */
    const resetFormEditOfficialDoc = () => {
      refreshFormEditOfficialDoc();
    };
    /**
     * 重置所有过滤值
     */
    const resetFilter = () => {
      resetFormEditOfficialDoc();
    };
    /**
     * 保存
     */
    const onSubmitOfficialDocClick = () => {
      formEditOfficialDocRef.value.validate(valid => {
        if (!valid) return;
        // 级联操作
        if (!props.saveOnSubmit) {
          let retFormData = {
            ...formData.OfficialDoc
          };
          retFormData.redTemplateIdDictMap = findItemFromList(redTemplateIdWidgetDropdownList.value, retFormData.redTemplateId, 'id');
          retFormData.securityLevelDictMap = findItemFromList(securityLevelWidgetDropdownList.value, retFormData.securityLevel, 'id');
          retFormData.securityRangeDictMap = findItemFromList(securityRangeWidgetDropdownList.value, retFormData.securityRange, 'id');
          retFormData.urgencyDictMap = findItemFromList(urgencyWidgetDropdownList.value, retFormData.urgency, 'id');
          retFormData.openLevelDictMap = findItemFromList(openLevelWidgetDropdownList.value, retFormData.openLevel, 'id');
          props.dialog?.submit(retFormData);
          return;
        }
        let params = {
          officialDocDto: {
            id: formData.OfficialDoc.id,
            redTemplateId: formData.OfficialDoc.redTemplateId,
            title: formData.OfficialDoc.title,
            enterpriseCharacter: formData.OfficialDoc.enterpriseCharacter,
            yearStr: formData.OfficialDoc.yearStr,
            numStr: formData.OfficialDoc.numStr,
            securityLevel: formData.OfficialDoc.securityLevel,
            securityRange: formData.OfficialDoc.securityRange,
            urgency: formData.OfficialDoc.urgency,
            openLevel: formData.OfficialDoc.openLevel,
            sendDate: formData.OfficialDoc.sendDate,
            sendDept: formData.OfficialDoc.sendDept,
            receiveDept: formData.OfficialDoc.receiveDept,
            content: formData.OfficialDoc.content,
            remark: formData.OfficialDoc.remark,
            attachFiles: formData.OfficialDoc.attachFiles,
            status: formData.OfficialDoc.status,
            flowStatus: formData.OfficialDoc.flowStatus,
            createUserId: formData.OfficialDoc.createUserId,
            createUserName: formData.OfficialDoc.createUserName,
            createTime: formData.OfficialDoc.createTime,
            updateUserId: formData.OfficialDoc.updateUserId,
            updateUserName: formData.OfficialDoc.updateUserName,
            updateTime: formData.OfficialDoc.updateTime,
            sendStatus: formData.OfficialDoc.sendStatus
          }
        };
        let httpCall = isEdit.value ? OfficialDocController.update : OfficialDocController.add;
        httpCall(params).then(res => {
          ElMessage.success('保存成功');
          props.dialog?.submit();
        }).catch(e => {
          // TODO: 异常处理
          console.error(e);
        });
      });
    };
    const formInit = () => {
      loadOfficialDocData().then(res => {
        redTemplateIdWidget.onVisibleChange(true).catch(e => {
          console.error(e);
        });
        securityLevelWidget.onVisibleChange(true).catch(e => {
          console.error(e);
        });
        securityRangeWidget.onVisibleChange(true).catch(e => {
          console.error(e);
        });
        urgencyWidget.onVisibleChange(true).catch(e => {
          console.error(e);
        });
        openLevelWidget.onVisibleChange(true).catch(e => {
          console.error(e);
        });
        let attachFilesDownloadParams = {
          id: formData.OfficialDoc.id,
          fieldName: 'attachFiles',
          asImage: false
        };
        attachFilesWidgetFileList.value = parseUploadData(formData.OfficialDoc.attachFiles, attachFilesDownloadParams);
        if (isEdit.value) refreshFormEditOfficialDoc();
      }).catch(e => {
        // TODO: 异常处理
        console.error(e);
      });
    };
    onMounted(() => {
      formInit();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_rich_editor = _resolveComponent("rich-editor");
      const _component_custom_upload = _resolveComponent("custom-upload");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_scrollbar, {
        class: "custom-scroll content-box"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formEditOfficialDocRef",
          ref: formEditOfficialDocRef,
          model: _unref(formData),
          size: _unref(layoutStore).defaultFormItemSize,
          rules: _unref(rules),
          "label-width": "120px",
          "label-position": "right",
          onSubmit: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["prevent"])),
          disabled: _ctx.disabled
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "套红模版",
                prop: "OfficialDoc.redTemplateId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.redTemplateId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).OfficialDoc.redTemplateId = $event),
                  placeholder: "请选择套红模版",
                  clearable: true,
                  filterable: true,
                  onVisibleChange: _unref(redTemplateIdWidget).onVisibleChange
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(redTemplateIdWidgetDropdownList), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "onVisibleChange"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "标题",
                prop: "OfficialDoc.title"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.title,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(formData).OfficialDoc.title = $event),
                  type: "text",
                  placeholder: "请输入标题",
                  clearable: true,
                  "show-word-limit": false,
                  maxlength: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "企字",
                prop: "OfficialDoc.enterpriseCharacter"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.enterpriseCharacter,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(formData).OfficialDoc.enterpriseCharacter = $event),
                  type: "text",
                  placeholder: "请输入企字",
                  clearable: true,
                  "show-word-limit": false,
                  maxlength: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "年份",
                prop: "OfficialDoc.yearStr"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.yearStr,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(formData).OfficialDoc.yearStr = $event),
                  type: "text",
                  placeholder: "请输入年份",
                  clearable: true,
                  "show-word-limit": false,
                  maxlength: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "第几号文",
                prop: "OfficialDoc.numStr"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.numStr,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(formData).OfficialDoc.numStr = $event),
                  type: "text",
                  placeholder: "请输入第几号文",
                  clearable: true,
                  "show-word-limit": false,
                  maxlength: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "保密级别",
                prop: "OfficialDoc.securityLevel"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.securityLevel,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(formData).OfficialDoc.securityLevel = $event),
                  placeholder: "请选择保密级别",
                  clearable: true,
                  filterable: true,
                  onVisibleChange: _unref(securityLevelWidget).onVisibleChange
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(securityLevelWidgetDropdownList), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "onVisibleChange"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "保密期限",
                prop: "OfficialDoc.securityRange"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.securityRange,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(formData).OfficialDoc.securityRange = $event),
                  placeholder: "请选择保密期限",
                  clearable: true,
                  filterable: true,
                  onVisibleChange: _unref(securityRangeWidget).onVisibleChange
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(securityRangeWidgetDropdownList), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "onVisibleChange"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "紧急程度",
                prop: "OfficialDoc.urgency"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.urgency,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(formData).OfficialDoc.urgency = $event),
                  placeholder: "请选择紧急程度",
                  clearable: true,
                  filterable: true,
                  onVisibleChange: _unref(urgencyWidget).onVisibleChange
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(urgencyWidgetDropdownList), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "onVisibleChange"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "公开级别",
                prop: "OfficialDoc.openLevel"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.openLevel,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(formData).OfficialDoc.openLevel = $event),
                  placeholder: "请选择公开级别",
                  clearable: true,
                  filterable: true,
                  onVisibleChange: _unref(openLevelWidget).onVisibleChange
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(openLevelWidgetDropdownList), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "onVisibleChange"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "发文日期",
                prop: "OfficialDoc.sendDate"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.sendDate,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(formData).OfficialDoc.sendDate = $event),
                  type: "date",
                  placeholder: "请选择发文日期",
                  clearable: true,
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "发文机构",
                prop: "OfficialDoc.sendDept"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.sendDept,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(formData).OfficialDoc.sendDept = $event),
                  placeholder: "请输入发文机构",
                  disabled: false
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "收文机构",
                prop: "OfficialDoc.receiveDept"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.receiveDept,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(formData).OfficialDoc.receiveDept = $event),
                  placeholder: "请输入收文机构",
                  disabled: false
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "公文内容",
                class: "rich-input",
                prop: "OfficialDoc.content"
              }, {
                default: _withCtx(() => [_createVNode(_component_rich_editor, {
                  ref: "content",
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.content,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(formData).OfficialDoc.content = $event),
                  disabled: _ctx.disabled
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注",
                prop: "OfficialDoc.remark"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  class: "input-item",
                  modelValue: _unref(formData).OfficialDoc.remark,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(formData).OfficialDoc.remark = $event),
                  type: "textarea",
                  placeholder: "请输入备注",
                  clearable: true,
                  "show-word-limit": false,
                  maxlength: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "附件",
                prop: "OfficialDoc.attachFiles"
              }, {
                default: _withCtx(() => [_createVNode(_component_custom_upload, {
                  modelValue: _unref(attachFilesWidgetFileList),
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _isRef(attachFilesWidgetFileList) ? attachFilesWidgetFileList.value = $event : null),
                  name: "uploadFile",
                  size: _unref(layoutStore).defaultFormItemSize,
                  type: "expand",
                  headers: _unref(getUploadHeaders),
                  action: _unref(getUploadActionUrl)('/admin/upms/officialDoc/upload'),
                  data: {
                    fieldName: 'attachFiles',
                    asImage: false
                  },
                  limit: _unref(attachFilesWidgetMaxCount),
                  onChange: onAttachFilesChange
                }, null, 8, ["modelValue", "size", "headers", "action", "limit"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "size", "rules", "disabled"])]),
        _: 1
      }), !_ctx.disabled ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0,
        class: "footer-box",
        type: "flex",
        justify: "end",
        align: "middle"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          size: _unref(layoutStore).defaultFormItemSize,
          onClick: _cache[16] || (_cache[16] = $event => onCancel())
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["size"]), _createVNode(_component_el_button, {
          size: _unref(layoutStore).defaultFormItemSize,
          type: "primary",
          onClick: _cache[17] || (_cache[17] = $event => onSubmitOfficialDocClick())
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }, 8, ["size"])]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [_createVNode(OfficialDocPreview, {
        doc: _unref(formData).OfficialDoc
      }, null, 8, ["doc"])])]);
    };
  }
});